import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/atos/form_cad'


function CadastrarAtosScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Ato Oficial do Governo" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarAtosScreen;